/* this file added by Bearer Web Developer  */
import { Button } from "@mui/material";
import styles from './management.module.scss';
import React, { useContext } from "react";
import { useAppState } from "../../../../../../states/app-state";
import { ReservedOrderInfoContext } from "../contexts/reservedOrderInfo";
import { observer } from "mobx-react-lite";
import { useThemeMode } from "../../../../../../states/contexts/theme";

const Management: React.FC = observer(() => {

    const reservedOrderInfo = useContext(ReservedOrderInfoContext);
    const appState = useAppState();
    const OpenManageOrder = () => {
        appState?.ReservedOrders?.setActiveManageOrder(reservedOrderInfo);
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.management} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <Button className={styles.management_button} onClick={OpenManageOrder}>
                <span>Manage the order</span>
                {
                    theme === "dark" ? <img src="/expand-address.png" alt="" width={24} height={24} /> :
                        <img src="/expand_more_right.png" alt="" width={15} height={22} />
                }
            </Button>
        </div>
    )
})

export default Management;